import Controller from '@ember/controller';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { service } from '@ember/service';

export default class RoadmapTableInitiativeSettingsStrategyController extends Controller {
  initiativeValidations = this.initiativeValidations;
  @service router;

  constructor() {
    super(...arguments);
  }

  @action
  resetForm(changeset, e) {
    e.preventDefault();
    changeset.rollback();
  }

  saveSettings = task({}, async (changeset, e) => {
    e.preventDefault();
    if (changeset.get('isDirty')) {
      this.nothingChanged = false;
      changeset.validate().then(() => {
        if (changeset.get('isValid')) {
          changeset
            .save()
            .then(() => {
              this.submittedOnce = true;
            })
            .catch((err) => {
              console.log(err, 'err');
              changeset
                .get(this, 'model.errors')
                .forEach(({ attribute, message }) => {
                  changeset.addError(attribute, message);
                });
            });
        }
      });
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.saveSettings.cancelAll();
    }
  });

  // beforePageExit(transition, changeset) {
  //   // console.log(changeset.get('source'), console.log(this.router));
  //   console.log(transition);
  //   transition.abort()
  // }
}
